module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/onesence-10-708348db0dc322761a8c997d4c558563.webp";